import { Fragment } from "react";
import { useTranslation } from "react-i18next";

import { formatConditionBadge } from "../conditionBadge";
import { getLogicLabel } from "../labels";
import type { FormRule } from "../schemas";
import { ConditionParts } from "./ConditionParts";

import type { SegmentField } from "@/features/segments/types";

type RuleSummaryProps = {
  rule: FormRule;
  fields: SegmentField[];
};

export function RuleSummary({ rule, fields }: RuleSummaryProps) {
  const { t } = useTranslation();
  const logicLabel = rule.type && getLogicLabel(t, rule.type);
  const summarized = rule.conditions.flatMap((condition) => {
    const parts = formatConditionBadge(condition, fields, t);
    return parts ? [{ condition, parts }] : [];
  });

  if (summarized.length === 0) return <>{t("admin.segments.builder.rule.empty")}</>;

  return (
    <span className="line-clamp-3">
      {summarized.map(({ condition, parts }, index) => (
        <Fragment key={condition.clientKey}>
          {index > 0 && logicLabel && (
            <span className="font-mono font-semibold tracking-wide"> {logicLabel} </span>
          )}
          <ConditionParts parts={parts} />
        </Fragment>
      ))}
    </span>
  );
}
